import script from "./LeveringsInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./LeveringsInfo.vue?vue&type=script&setup=true&lang=js"

import "./LeveringsInfo.vue?vue&type=style&index=0&id=83f94a3e&lang=css"

const __exports__ = script;

export default __exports__